/* ==========================================================================
   SearcherTrainHotel > Constants
   ========================================================================== */

/* Exports */
module.exports = {
    ORIGIN: {
        icon: 'marker',
        types: ['EST']
    },
    DESTINATION: {
        icon: 'earth-planet',
        types: ['CIU', 'ZON'],
        operator: 'or',
        options: ['PAK']
    },
    CALENDAR: {
        mode: 'range',
        DATE_FORMAT: 'yyyy-LL-dd',
        stringDateFormat: 'dd LLLL yyyy',
        dateFormat: 'Y-m-d',
        ariaDateFormat: 'Y-m-d',
        static: true,
        inline: true,
        showMonths: 2,
        sameDay: false,
        releaseDays: 2
    },
    ACCOMMODATION: {
        maxRooms: 4,
        maxPeople: 9,
        adults: {
            min: 1,
            max: 6,
            value: 1
        },
        children: {
            min: 0,
            max: 4,
            value: 0,
            maxAge: 11,
            defaultAge: 7
        },
        rooms: [
            {
                adults: 2,
                children: 0
            }
        ]
    },

    LOADING: {
        LOADING_SRC: '/contenidos/fotos/CIUDADES/',
        LOADING_ALTERNATIVE: '/comun/images/lineas/trenes_800x600.jpg'
    }
};
